import {useEffect} from 'react';
import {useIsAuthenticated} from '../../../Authentication/hooks/useIsAuthenticated';

let WAS_COUPON_WALLET_OPENED = false;

export const useShowNewCouponsNotificationBadge = (couponsCount: number) => {
  const showBadge = WAS_COUPON_WALLET_OPENED ? false : couponsCount > 0;
  const {isAuthenticated} = useIsAuthenticated();

  useEffect(() => {
    if (isAuthenticated) {
      WAS_COUPON_WALLET_OPENED = false;
    }
  }, [isAuthenticated]);

  const setCouponWalletWasOpened = () => {
    WAS_COUPON_WALLET_OPENED = true;
  };

  return {
    showNewCouponsNotificationBadge: showBadge,
    setCouponWalletWasOpened,
  };
};
